import { render, staticRenderFns } from "./EditableNoveltyItem.vue?vue&type=template&id=0ea51c67&"
import script from "./EditableNoveltyItem.vue?vue&type=script&lang=ts&"
export * from "./EditableNoveltyItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports